import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var AudioFile = /*#__PURE__*/function (_Entity) {
  _inherits(AudioFile, _Entity);

  var _super = _createSuper(AudioFile);

  function AudioFile() {
    _classCallCheck(this, AudioFile);

    return _super.apply(this, arguments);
  }

  _createClass(AudioFile, [{
    key: "url",
    get: function get() {
      return this.props.url;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "size",
    get: function get() {
      return this.props.size;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return {
        id: this.id.toString(),
        url: this.url,
        type: this.type,
        size: this.size
      };
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var guardCollections = [{
        argument: props.url,
        argumentName: 'Signed Url'
      }, {
        argument: props.size,
        argumentName: 'Size'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok(new AudioFile(props, new UniqueEntityID(id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      var id = data.id,
          url = data.url,
          type = data.type,
          size = data.size;
      return this.create({
        url: url,
        type: type,
        size: size
      }, id);
    }
  }]);

  return AudioFile;
}(Entity);